import logging from '../logging';
import { CommandManager } from '../managers/command-manager';

const log = logging('components');


/**
 * Dispatches a global CustomEvent when clicked. The type of the command can be
 * configured by the "action" attribute.
 */
export default class CommandButton extends HTMLElement {

    connectedCallback() {
        this.addEventListener('click', () => {
            const
                action = this.getAttribute('action'),
                channel = this.getAttribute('channel') ?? 'app-command';
            log.debug(`CommandButton.click ${channel} ${action}`);

            CommandManager.do(channel, action);
        });
    }
}

// Note that this custom element is used in both the floor planner and the
// cps.js bundles. This creates a conflict. I do want to move the floor planner
// into the cps.js bundle, but for the moment it is much easier to work around
// this by just catching the exception.
try {
    window.customElements.define('command-button', CommandButton);
    log.debug('Defined custom element <command-button>');
} catch(error) {
    log.warn('Expected error due to bundling the same web component into two scripts. See src/components/command-button.ts', error);
}
